import { render, staticRenderFns } from "./pricing.vue?vue&type=template&id=bea2395e&scoped=true"
import script from "./pricing.vue?vue&type=script&lang=js"
export * from "./pricing.vue?vue&type=script&lang=js"
import style0 from "./pricing.vue?vue&type=style&index=0&id=bea2395e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea2395e",
  null
  
)

export default component.exports